module.exports = __webpack_public_path__ + "static/assets/f9a4ad402db52eaa7496fe9698b2d5cd.svg";